// LanguageContext.js
import React, { createContext, useContext, useState } from 'react';
import translations from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en'); // Default is English

  const toggleLanguage = () => {
    setLanguage(prevLang => (prevLang === 'en' ? 'dz' : 'en'));
  };

  const t = (key) => {
    return translations[language][key] || key; // fallback to key if translation missing
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
